export const DOMAIN_NAME = 'OutputView'
export const PAGE = `${DOMAIN_NAME}.ReportPivot`
export const TITLE = `${PAGE}.TITLE`

export const TABLE = `${PAGE}.Table`
export const COLUMN_TABLE = `${TABLE}.Column`
export const COLUMN_TABLE_HEADER_NAME = {
  SETTIMANACOMMERCIALE: `${COLUMN_TABLE}.SETTIMANACOMMERCIALE`,
  NOMEIPOTESI: `${COLUMN_TABLE}.NOMEIPOTESI`,
  STATO: `${COLUMN_TABLE}.STATO`,
  ARTICOLO: `${COLUMN_TABLE}.ARTICOLO`,
  ARTICOLO_DESC: `${COLUMN_TABLE}.ARTICOLO_DESC`,
  ENTE: `${COLUMN_TABLE}.ENTE`,
  ZONA: `${COLUMN_TABLE}.ZONA`,
  STRUCTURE: `${COLUMN_TABLE}.STRUCTURE`,
  EXPLENABILITY: `${COLUMN_TABLE}.EXPLENABILITY`,
  CATEGORY: `${COLUMN_TABLE}.CATEGORY`,
  APC: `${COLUMN_TABLE}.APC`,
  SEASON: `${COLUMN_TABLE}.SEASON`,
  COMMODITY: `${COLUMN_TABLE}.COMMODITY`,
  QTY: `${COLUMN_TABLE}.QTY`,
  ITRP: `${COLUMN_TABLE}.ITRP`,
  VALORE: `${COLUMN_TABLE}.VALORE`,
  ENTEDESCENTE: `${COLUMN_TABLE}.ENTEDESCENTE`,
  ENTEANDDESC: `${COLUMN_TABLE}.ENTEANDDESC`,
  MANDATORYARTICLE: `${COLUMN_TABLE}.MANDATORYARTICLE`,
  SOURCE: `${COLUMN_TABLE}.SOURCE`
}
